export default "__VITE_ASSET__Dwkuzlyr__"